function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M276.4 198.5H248v-77.9c0-31.9-11-61-30.9-81.8-19.6-20.4-46.3-31.7-75.3-31.7S86 18.3 66.4 38.7c-20 20.8-30.9 49.8-30.9 81.8v77.9H7.1v28.4h85.1v7.1c0 23.4 22.2 42.5 49.5 42.5s49.6-19 49.6-42.5v-7.1h85.1v-28.3zm-212.6-78c0-49.3 32.8-85.1 77.9-85.1s78 35.8 78 85.1v77.9H63.8v-77.9zm99.3 113.4c0 7.6-10 14.2-21.3 14.2s-21.3-6.6-21.3-14.2v-7.1h42.7v7.1h-.1z"
})));